import React from 'react'
import LocaleSelector from './LocaleSelector'
import RegionSelector from './RegionSelector'
import { Feature } from '@cbgms/base/feature-flags'
import OperationUnitSelector from './OperationUnitSelector'
import BreadcrumbsPath from '@carsys/ui/src/BreadcrumbsPath'
import BreadcrumbsNameMapping from 'app-support/BreadcrumbsNameMapping'
import UserMenu from './UserMenu'
import { Grid } from '@mui/material'

const Header: React.FC<{}> = () => {
  return (
    <Grid
      data-testid='header-menu'
      container
      direction='row'
      borderBottom='3px solid'
      minHeight='75px'
      justifyContent='space-between'
      sx={theme => ({
        borderBottomColor: theme.palette.primary.main
      })}
    >
      <Grid container item alignItems='center' width='max-content' ml={2}>
        <BreadcrumbsPath breadcrumbsMap={BreadcrumbsNameMapping} />
      </Grid>
      <Grid container item direction='row' width='max-content' pr={3} gap={2}>
        <Feature feature='admin-ui-ou-menu'>
          <Grid item>
            <OperationUnitSelector />
          </Grid>
        </Feature>
        <Grid item>
          <LocaleSelector />
        </Grid>
        <Grid item>
          <RegionSelector />
        </Grid>
        <Grid item>
          <UserMenu />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Header
